import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import firebase from "./utils/firebase";
import { UserContext } from "./Context";
import _ from "lodash";
import store from "store";

import { Helmet } from "react-helmet";

import ErrorBoundary from "./components/errorBoundary/ErrorBoundary";
import Header from "./components/header/Header";
import Listing from "./pages/listing/Listing";
import My from "./pages/my/My";
import Profile from "./pages/profile/Profile";
import Home from "./pages/home/Home";
import Footer from "./components/footer/Footer";
import Admin from "./pages/admin/Admin";
import LoginModal from "./components/LoginModal/LoginModal";
import Flags from "./components/flags/Flags";

import "./App.css";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBath,
  faBed,
  faCar,
  faEnvelope,
  faHeart,
  faFax,
  faPhone,
  faUser
} from "@fortawesome/free-solid-svg-icons";

import { Title, CanonicalURI, GetToken } from "./utils/consts";
import Application from "./pages/application/Application";
const heart = require("@fortawesome/fontawesome-free-regular/faHeart");
library.add(faBed);
library.add(faBath);
library.add(faCar);
library.add(faEnvelope);
library.add(faPhone);
library.add(faFax);
library.add(faUser);
library.add(faHeart);
library.add(heart);

const initState = {
  my: {},
  myLoading: true,
  application: {},
  applicationLoading: true,
  user: null,
  userLoading: true,
  unsubscribers: [],
  loginModal: false
};

const flagAppearances = ["error", "info", "normal", "success", "warning"];

export default class App extends Component {
  constructor() {
    super();
    this.state = {
      ...initState,
      loginModalHandler: this.loginOpenHandler,
      addFlag: this.addFlag,
      flags: []
    };
  }

  componentDidMount() {
    this.setState({ userLoading: true });
    this.addChat();
    this.checkIfLoggingIn();
    firebase.auth().onAuthStateChanged(user => {
      // console.log(user);
      if (user) {
        console.log(user);
        this.customClaims();
        this.setState({ userLoading: false, user, myLoading: true });
        this.setMyStuffListener(user.uid);
        this.setApplicationListener(user.uid);
      } else {
        if (this.state.user) {
          this.unsubscribe();
          // this.unsubMyStuffListener(this.state.user.uid);
          // this.unsubApplicationListener(this.state.user.uid);
        }
        this.setState(initState);
        this.setState(...initState, {
          userLoading: false,
          my: null,
          myLoading: false,
          application: null,
          applicationLoading: false
        });
      }
    });
  }

  // setAuthStateListener = () => {

  // }

  addChat = () => {
    window.$crisp = [];
    window.CRISP_WEBSITE_ID = "fa420eac-4b8e-401e-9be1-2c36bf867117";
    (function() {
      const d = document;
      const s = d.createElement("script");
      s.src = "https://client.crisp.chat/l.js";
      s.async = 1;
      d.getElementsByTagName("head")[0].appendChild(s);
    })();
  };

  customClaims = () => {
    GetToken()
      .then(idTokenResult => {
        this.setState({ custom: idTokenResult.claims });
      })
      .catch(error => console.log(error));
  };

  unsubscribe = () => {
    console.log("unsubscribing");
    this.state.unsubscribers.forEach(item => {
      console.log(item);
      item();
    });
  };

  componentWillUnmount() {
    if (!_.isEmpty(this.state.user) && !!this.state.user.uid) {
      this.unsubscribe();
    }
  }

  setApplicationListener = uid => {
    firebase
      .firestore()
      .collection("application")
      .doc(uid)
      .onSnapshot(
        doc => {
          this.setState({ application: doc.data(), applicationLoading: false });
        },
        error => {
          this.setState({
            flag: {
              title: "Connection Error"
            }
          });
          console.log(error);
        }
      );
    const { unsubscribers } = this.state;
    const unsubApplicationListener = firebase
      .firestore()
      .collection("application")
      .doc(uid)
      .onSnapshot(() => {});
    unsubscribers.push(unsubApplicationListener);
    this.setState({ unsubscribers });
  };

  setMyStuffListener = uid => {
    firebase
      .firestore()
      .collection("my")
      .doc(uid)
      .onSnapshot(
        doc => {
          this.setState({ my: doc.data(), myLoading: false });
        },
        error => {
          this.setState({
            flag: {
              title: "Connection Error"
            }
          });
          console.log(error);
        }
      );

    const { unsubscribers } = this.state;
    const unsubMyStuffListener = firebase
      .firestore()
      .collection("my")
      .doc(uid)
      .onSnapshot(() => {});
    unsubscribers.push(unsubMyStuffListener);
    this.setState({ unsubscribers });
  };

  checkIfLoggingIn = () => {
    if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
      let email = store.get("emailForSignIn");
      if (!email) {
        email = window.prompt("Please provide your email for confirmation");
      }
      //TODO error handling
      if (!!email) {
        firebase
          .auth()
          .signInWithEmailLink(email, window.location.href)
          .then(result => {
            console.log(result);
            store.remove("emailForSignIn");
            const continueUrl = store.get("continueUrl");
            window.history.pushState({}, "", `${continueUrl}`);
            store.remove("continueUrl");
          })
          .catch(error => {
            this.setState({
              flag: {
                title: "Connection Error"
              }
            });
            console.log(error);
          });
      }
    }
  };

  loginOpenHandler = () =>
    this.setState({ loginModal: !this.state.loginModal });

  addFlag = flag => {
    const appearance = flagAppearances[flag.appearance];
    flag.appearance = appearance;
    // this.setState({ flag });
    // const newFlagId = this.state.flags.length + 1;
    const flags = this.state.flags.slice();
    flags.splice(0, 0, flag);

    this.setState({ flags });
  };

  handleDismiss = () => {
    this.setState({ flags: [] });
    // this.setState(prevState => ({
    //   flags: prevState.flags.slice(1)
    // }));
  };

  render() {
    // console.log(this.state);
    return (
      <UserContext.Provider value={this.state}>
        <ErrorBoundary>
          <Router>
            <div className="app">
              <Helmet>
                <meta charSet="utf-8" />
                <title>{Title}</title>
                <link rel="canonical" href={CanonicalURI} />
              </Helmet>
              <Header />
              <div className="body">
                <Switch>
                  <Route exact path="/" component={Home} />
                  <Route
                    path="/listing/:lid"
                    render={props => (
                      <Listing addFlag={this.state.addFlag} {...props} />
                    )}
                  />
                  <Route path="/my" render={props => <My {...props} />} />
                  <Route
                    path="/profile"
                    render={props => <Profile {...props} />}
                  />
                  <Route path="/admin" render={props => <Admin {...props} />} />
                  <Route
                    path="/application/:uid"
                    render={props => (
                      <Application addFlag={this.state.addFlag} {...props} />
                    )}
                  />
                </Switch>
              </div>
              {this.state.loginModal && (
                <LoginModal loginOpenHandler={this.loginOpenHandler} />
              )}
              <Footer />
              {
                <Flags
                  flags={this.state.flags}
                  handleDismiss={this.handleDismiss}
                />
              }
            </div>
          </Router>
        </ErrorBoundary>
      </UserContext.Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js